<!-- 探测类型取样值  位于轮播图之间-->
<template>
  <div class="middle-height">
    <table class="width-100 uk-table-middle  uk-table-divider uk-text-center">
      <tr style="height:25px;line-height: 25px;" class="bd-t bd-l bd-r">
        <td style="overflow:hidden" class="uk-position-relative">
          <i
            class="iconfont icon-wenduji color-theme cursor-pointer uk-position-absolute"
            :class="{ 'color-orange': sample.type === 'sample' }"
            style="left:5px"
            :title="sampleType"
            v-if="sample.code === 'temp'"
          ></i>
          <i
            class="iconfont icon-wenshiduji color-theme cursor-pointer uk-position-absolute"
            :class="{ 'color-orange': sample.type === 'sample' }"
            style="left:5px"
            :title="sampleType"
            v-else
          ></i>
          {{ $timetransition(sample.time) }}
        </td>
      </tr>
      <tr style="height: 25px">
        <!-- <td>
            {{ $t(carrierTypeConvert(carrierTypeId).title) }} {{ $t('public.sample') }}<span v-if="sampleValue.time">-{{ $timetransition(sampleValue.time) }}</span>
        </td> -->
        <td class="bg-theme color-white bd-l-theme bd-r-theme">
          <span v-if="sample.isRange === 0">
            <!--{{ sample.rangeName }}-->

            <!-- 只有是Probe时才在同一行展示区间 -->
            <span v-if="sample.type === 'probe'">
              {{
                `${formatTempValue(sample.min) + '' + unit[sample.code].name} ~ ${formatTempValue(sample.max) +
                  '' +
                  unit[sample.code].name}`
              }}
            </span>
          </span>
          <span v-else>
            <span v-if="sample.code === 'temp'">{{
              $t('integration.unrelated_temperature_range')
            }}</span>
            <span v-else-if="sample.code === 'hum'">{{
              $t('integration.unrelated_humidity_range')
            }}</span>
          </span>
        </td>
      </tr>
      <tr style="height: 40px" v-if="sample.type === 'sample'">
        <!-- 没有取样值用---标识 -->
        <td class="table-value bd-l bd-r">
          <template>
            {{ formatTempValue(sampleValue.val) }}{{ unit[sampleValue.code].name }}</template
          >
        </td>
      </tr>
      <tr style="height: 25px" v-if="sample.type === 'sample'">
        <td class="bg-theme color-white bd-l-theme bd-r-theme">
          <span v-if="sample.min !== undefined && sample.max !== undefined">{{
            `${formatTempValue(sample.min) + '' + unit[sample.code].name} ~ ${formatTempValue(sample.max) +
              '' +
              unit[sample.code].name}`
          }}</span>
          <span v-else></span>
        </td>
      </tr>
    </table>

    <div
      :style="
        `height: calc(100% - ${
          sample.type === 'sample' ? '120px' : '55px'
        });overflow-y: auto`
      "
    >
      <div>
        <div
          v-for="(item, index) in sampleValue.itemMap"
          :key="index"
          class="probe"
          :class="{ 'color-gray': item.effect === 0 }"
        >
          <div
            class="uk-flex "
            style="border-bottom: 1px solid #344962; height: 22px;line-height: 22px;"
          >
            <div class="uk-flex width-100">
              <div class="uk-flex">
                <!-- 图标 -->
                <div style="width:20px;" class="border-right">
                  <i
                    v-icon="['sensorTypeConvert', item.type]"
                    style="margin-left:3px"
                  ></i>
                  <!-- <i :class="equiIconConvert"></i> -->
                </div>
                <div style="width:20px" class="border-right uk-text-center">
                  <i
                    v-icon="['equiStatusConvert', item.status]"
                    style="margin-left:2px"
                  ></i>
                </div>
              </div>
              <div class="uk-flex-1 border-right">
                <el-tooltip
                  placement="top"
                  v-if="item.fullPath && item.description"
                >
                  <span class="cursor-pointer">{{ item.no }} </span>
                  <div slot="content">
                    <div>{{ item.fullPath }}</div>
                    <div>{{ item.description }}</div>
                  </div>
                </el-tooltip>
                <span v-else>
                  <span class="cursor-pointer ellipsis ">{{ item.no }}</span>
                </span>
              </div>

              <!-- 温/湿度值 -->
              <div
                style="width:70px;"
                v-range="[item.val, sample, 'background']"
                class="border-box uk-text-middle"
              >
                <span style="margin-top:3px">
                  {{ formatTempValue(item.val)  }}
                  {{ unit[sample.code].name }}
                </span>
              </div>
            </div>
          </div>
          <div class="uk-flex" style="height:22px;line-height:22px">
            <!-- 时间 -->
            <div class="uk-flex-1 border-right">
              <span>{{ item.time ? $timetransition(item.time) : '---' }}</span>
            </div>

            <div style="width:70px" class="uk-flex">
              <div class="border-right" style="width:35px">
                <i
                  class="el-icon-document cursor-pointer"
                  :title="$t('public.details')"
                  @click="sensorDetail(item)"
                ></i>
              </div>
              <div style="width:35px" class="driver-item-sample-chart">
                <i
                  class="iconfont icon-zhexiantu s-c-right-icon cursor-pointer"
                  @click="historyData(item)"
                  :title="$t('device.history_data')"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  carrierTypeConvert,
  defaultUnit,
  equiIconConvert,
  equiStatusConvert
} from '@/utils/convert'

import { probeHistory } from '@/utils/winDetail'
import SampleValue from '@/components/SampleValue/SampleValue.vue'

import bus from '../../utils/bus'
import { sensorTypeConvert } from '@/utils/dict/sensor'
import { TempUtils } from '@/utils/TempUtil.js';
export default {
  props: {
    sample: {
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      type: String,
      default: 'temp'
    },
    carrierTypeId: {
      type: Number,
      default: 1
    },
    scopeName: {},
    carrierName: {},
    carrierId: {},
    sceneId: {},
    carrierInfo: {}
  },
  components: {
    SampleValue
  },
  watch: {
    sample: {
      immediate: true,
      handler (newval) {
        this.sampleValue = newval
      }
    }
  },
  data () {
    return {
      equiIconConvert,
      sensorTypeConvert,
      equiStatusConvert,
      carrierTypeConvert,
      sampleValue: {},
      defaultUnit
    }
  },
  mounted () {},
  methods: {
    formatTempValue(val) {
      if (val === null || val === undefined || val === '') return '--'
      const numVal = Number(val)
      if (isNaN(numVal)) return '--'

      const result = TempUtils.convertToCelsius(numVal, this.unit[this.sample.code].name);
      return `${result}`
    },
    historyData (item) {
      console.log(item)
      // sensorHistory(item.id, item.no, JSON.stringify(this.sampleValue), this.scopeName, this.carrierName, this.carrierId, this.carrierTypeId);
      const { id, keycode, typeId } = this.carrierInfo
      probeHistory(
        this.carrierId || id,
        this.carrierName || keycode,
        this.carrierTypeId || typeId,
        item.id,
        item.no,
        item.type
      )
    },

    // 传感器详情 注:必须将组件放入父级组件的页面中 vue2 没有transport插入到Body节点 自定义后用bus触发会碰到问题
    sensorDetail (item) {
      // bus.$emit('sensorParam', item.id, item.no);
      bus.$emit('probeParam', {
        probeCode: item.id,
        carrierType: this.carrierTypeId,
        sceneId: this.sceneId || this.carrierInfo.sceneId,
        carrierId: this.carrierInfo.id
      })
    }
  },
  computed: {
    // unit() {
    //     if (this.sample) {
    //         return defaultUnit[this.sample.code];
    //     }
    // },
    // 采样类型
    sampleType () {
      let resultStr = ''
      if (this.sample.type === 'probe') {
        resultStr = $t('integration.current')
      }
      resultStr +=
        this.sample.code === 'temp'
          ? $t('integration.temperature')
          : $t('integration.humidity')
      // 采集:实时数据
      resultStr +=
        this.sample.type === 'sample'
          ? $t('integration.sampling')
          : $t('integration.collection')
      return resultStr
    }
  }
}
</script>

<style scoped lang="scss">
.height-32 {
  height: 32px;
  line-height: 32px;
}

.border-right {
  border-right: solid #344962 1px;
}
</style>
